// Function to check if viewport width is less than 768px
function isViewportSmall() {
  return $(window).width() < 768;
}

$(document).ready(function () {
  function setDefaultSubscriptionPlan() {
    if ($(".product__bundle-data").length > 0) {
      // Find the second subscription plan (3-month variant) instead of the first
      const $secondSubscriptionPlan = $(
        ".product__bundle-data.subscription-bundle"
      ).eq(1);

      if ($secondSubscriptionPlan.length > 0) {
        const subscriptionId = $secondSubscriptionPlan.attr(
          "data-subscription-id"
        );

        if (subscriptionId) {
          // Set the subscription plan as selected
          $secondSubscriptionPlan.addClass("selected-plan");

          // Update the hidden input field
          $(".product-form .product-selling-plan-id").val(subscriptionId);

          // Update the variant ID if available
          const variantId = $secondSubscriptionPlan.attr("data-variant-id");
          if (variantId) {
            $(".product-form .product-variant-id").val(variantId);
          }

          // Update pricing display for subscription bundle
          const totalPrice = $secondSubscriptionPlan.attr("data-price");
          const totalComparePrice =
            $secondSubscriptionPlan.attr("data-compare-price");
          const bottleQty = parseInt(
            $secondSubscriptionPlan
              .find("[data-bottle_qty]")
              .first()
              .attr("data-bottle_qty") || "1"
          );

          if (totalPrice && totalComparePrice) {
            // Calculate per-item prices
            const pricePerItem = calculatePerItemPrice(totalPrice, bottleQty);
            const comparePricePerItem = calculatePerItemPrice(
              totalComparePrice,
              bottleQty
            );

            // Display per-item prices
            $(".subscription-bundle-price-compare").text(comparePricePerItem);
            $(".subscription-bundle-price b").text(pricePerItem);

            // Display total prices
            $(".product-bundle__label").text(
              "Save " + $secondSubscriptionPlan.attr("data-savings") + "%"
            );
            $(".product-bundle__total-price-value").text(totalPrice);

            const priceCompareNum = totalComparePrice.replace(/[$,]/g, "");
            const priceNum = totalPrice.replace(/[$,]/g, "");
            const save = Number(priceCompareNum) - Number(priceNum);
            $(".product-bundle__total-save-value").text(
              "$" + (save > 0 ? save.toFixed(2) : "0.00")
            );

            // Copy save percentage
            const savePercentText = $secondSubscriptionPlan
              .find(".product-save-precent b")
              .text();
            if (savePercentText) {
              $(".subscription-bundle-head-text-percent").text(savePercentText);
            }
          }
        }
      }
    }
  }

  setTimeout(setDefaultSubscriptionPlan, 200);

  // Function to handle FAQ page accordion
  function handleAccordion() {
    if (isViewportSmall()) {
      $(".footer-block--menu .footer-block__details-content").hide();

      $(document).on(
        "click",
        "footer .footer-block--menu .footer-block__heading",
        function () {
          const $heading = $(this);
          const $parent = $heading.parent();
          const $content = $heading.next(".footer-block__details-content");
          const $chevron = $heading.find("svg");

          $parent.toggleClass("active-dropdown-footer");

          $content.slideToggle();

          if ($parent.hasClass("active-dropdown-footer")) {
            $chevron.css("transform", "rotate(180deg)");
          } else {
            $chevron.css("transform", "rotate(0deg)");
          }
        }
      );
    } else {
      $(".footer-block--menu .footer-block__details-content").show();
    }
  }

  handleAccordion();

  $(window).on("resize", function () {
    handleAccordion();
  });

  // Header Sub Menu Scrolling Handling (Hide on scroll)
  var submenu = document.querySelector(".header__submenu-container");

  window.addEventListener("scroll", function () {
    document
      .querySelectorAll("header details[open]")
      .forEach(function (details) {
        details.removeAttribute("open");
        var summary = details.querySelector('summary[aria-expanded="true"]');
        if (summary) summary.removeAttribute("aria-expanded");
      });
    if (submenu) submenu.style.display = "none";
  });

  document.addEventListener("click", function (e) {
    if (e.target.closest("header details > summary")) {
      if (submenu) submenu.style.display = "";
    }
  });

  // Generic Slider Initialization
  function initGenericSlider(selector, options) {
    const $slider = $(selector);

    if ($slider.length && !$slider.hasClass("slick-initialized")) {
      const $images = $slider.find("img");
      let imagesLoaded = 0;
      const totalImages = $images.length;

      if (totalImages === 0) {
        initializeSlick();
      } else {
        $images.each(function () {
          if (this.complete) {
            imagesLoaded++;
            checkImagesLoaded();
          } else {
            $(this).on("load", function () {
              imagesLoaded++;
              checkImagesLoaded();
            });
          }
        });
      }

      function checkImagesLoaded() {
        if (imagesLoaded === totalImages) {
          initializeSlick();
        }
      }

      function initializeSlick() {
        if ($slider.hasClass("slick-initialized")) {
          $slider.slick("unslick");
        }

        $slider.slick(options);

        setTimeout(() => {
          $slider.slick("setPosition");
          if (
            isViewportSmall() &&
            selector === ".collection-slider ul.product-grid"
          ) {
            $slider.slick("slickGoTo", 1);
          }
        }, 100);
      }
    } else if ($slider.hasClass("slick-initialized")) {
      $slider.slick("setPosition");
      if (
        isViewportSmall() &&
        selector === ".collection-slider ul.product-grid"
      ) {
        $slider.slick("slickGoTo", 1);
      }
    }
  }

  function initAllSliders() {
    // Collection Slider
    initGenericSlider(".collection-slider ul.product-grid", {
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      variableWidth: true,
      dots: false,
      appendDots: $(".collection-slider .slick-slider-dots"),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            dots: true,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            dots: true,
            centerMode: true,
            centerPadding: "60px",
          },
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 1,
            dots: true,
            centerMode: true,
            centerPadding: "30px",
          },
        },
      ],
    });

    // Category Slider
    initGenericSlider(".category-slider ul.product-grid", {
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 750,
          variableWidth: false,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    // Reviews Slider
    initGenericSlider(".reviews-slider ul.product-grid", {
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      rows: 1,
      dots: false,
      centerMode: false,
      useTransform: false,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            dots: true,
            centerMode: true,
            centerPadding: "0px",
            appendDots: $(".reviews-slider .slick-slider-dots"),
          },
        },
        {
          breakpoint: 9999,
          settings: "unslick",
        },
      ],
    });
  }

  // Initialize sliders on document ready
  setTimeout(() => {
    initAllSliders();
  }, 500);

  // Reinitialize sliders on window resize
  $(window).on("resize", function () {
    initAllSliders();
  });

  // Set initial variant ID
  const $productId = $(".product__bundle-data.subscription-bundle")
    .first()
    .attr("data-variant-id");

  if ($productId) {
    $("input.product-variant-id").val($productId);
  }

  // Product Gallery Mobile Slider Counter Circles
  setTimeout(function () {
    document.querySelectorAll("slider-component").forEach(function (slider) {
      const counterCircles = slider.querySelectorAll(".slider-counter__circle");
      const currentPageEl = slider.querySelector(".slider-counter--current");
      const sliderList = slider.querySelector(".slider");
      const sliderItems = slider.querySelectorAll('[id^="Slide-"]');
      if (
        !counterCircles.length ||
        !currentPageEl ||
        !sliderList ||
        !sliderItems.length
      )
        return;

      function updateCircles() {
        const current = parseInt(currentPageEl.textContent, 10) || 1;
        counterCircles.forEach((circle, idx) => {
          if (idx === current - 1) {
            circle.classList.add("is-active");
          } else {
            circle.classList.remove("is-active");
          }
        });
      }

      sliderList.addEventListener("scroll", updateCircles);
      slider.addEventListener("slideChanged", updateCircles);

      // Make circles clickable
      counterCircles.forEach((circle, idx) => {
        circle.style.cursor = "pointer";
        circle.addEventListener("click", function () {
          const targetSlide = sliderItems[idx];
          if (targetSlide) {
            sliderList.scrollTo({
              left: targetSlide.offsetLeft,
              behavior: "smooth",
            });
          }
        });
      });

      updateCircles();
    });

    $(document).on("click", ".slider-button--prev", function () {
      console.log("prev");
      const $slider = $(".product-media-list");
      $slider.slick("slickPrev");
    });

    $(document).on("click", ".slider-button--next", function () {
      console.log("next");
      const $slider = $(".product-media-list");
      $slider.slick("slickNext");
    });
  }, 700);

  $(document).on("click", ".product__bundle-data", function () {
    $(this).parent().find(".product__bundle-data").removeClass("selected-plan");
    $(this).addClass("selected-plan");

    // Find and update corresponding element in all-data-products container
    const index = $(this).index();
    $(
      ".single-tab-data:not(.active-tab-detail) .all-data-products .product__bundle-data"
    )
      .eq(index)
      .addClass("selected-plan")
      .siblings()
      .removeClass("selected-plan");

    $(".product-form__submit .product-price-total-btn").text(
      $(this).find(".final-product-price").text()
    );
    $(".product product-form .product-variant-id").val(
      $(this).attr("data-variant-id")
    );
    $(".product product-form .product-selling-plan-id").val(
      $(this).attr("data-subscription-id")
    );

    if ($(this).attr("data-product-avail") == "true") {
      $(".product .add-soldout-text").text("Add To Cart");
      $(".product .product-form__buttons .product-form__submit").removeAttr(
        "disabled",
        ""
      );
    } else {
      $(".product .add-soldout-text").text("Sold Out");
      $(".product .product-form__buttons .product-form__submit").attr(
        "disabled",
        ""
      );
    }

    if ($(".product__info-wrapper").hasClass("commin-soon-product")) {
      $(".product .add-soldout-text").text("Coming Soon");
    }

    if ($(".product .product-form__buttons").hasClass("notify-popup-trigger")) {
      $(".product .add-soldout-text").text("COMING SOON - NOTIFY WHEN READY");
    }

    const totalPrice = $(this).attr("data-price");
    const totalComparePrice = $(this).attr("data-compare-price");
    const bottleQty = parseInt(
      $(this).find("[data-bottle_qty]").first().attr("data-bottle_qty") || "1"
    );

    // Calculate per-item prices
    const pricePerItem = calculatePerItemPrice(totalPrice, bottleQty);
    const comparePricePerItem = calculatePerItemPrice(
      totalComparePrice,
      bottleQty
    );

    if ($(this).hasClass("one-time-bundle")) {
      // Display per-item prices
      $(".one-time-bundle-price-compare").text(comparePricePerItem);
      $(".one-time-bundle-price b").text(pricePerItem);

      const $subsItem = $(
        ".product-bundle__data-subscription .product__bundle-data.selected-plan"
      );
      const subsPricePerItem = calculatePerItemPrice(
        $subsItem.attr("data-price"),
        bottleQty
      );
      const subsComparePricePerItem = calculatePerItemPrice(
        $subsItem.attr("data-compare-price"),
        bottleQty
      );
      $(".subscription-bundle-price-compare").text(subsComparePricePerItem);
      $(".subscription-bundle-price b").text(subsPricePerItem);
    }

    if ($(this).hasClass("subscription-bundle")) {
      // Display per-item prices
      $(".subscription-bundle-price-compare").text(comparePricePerItem);
      $(".subscription-bundle-price b").text(pricePerItem);

      const $oneTimeItem = $(
        ".one-time-bundle-data .product__bundle-data.selected-plan"
      );
      const oneTimePricePerItem = calculatePerItemPrice(
        $oneTimeItem.attr("data-price"),
        bottleQty
      );
      const oneTimeComparePricePerItem = calculatePerItemPrice(
        $oneTimeItem.attr("data-compare-price"),
        bottleQty
      );
      $(".one-time-bundle-price-compare").text(oneTimeComparePricePerItem);
      $(".one-time-bundle-price b").text(oneTimePricePerItem);

      // Copy save percentage from product-save-precent to subscription-bundle-head-text-percent
      const savePercentText = $(this).find(".product-save-precent b").text();
      if (savePercentText) {
        $(".subscription-bundle-head-text-percent").text(savePercentText);
      }
    }

    // Display total prices
    $(".product-bundle__label").text(
      "Save " + $(this).attr("data-savings") + "%"
    );
    $(".product-bundle__total-price-value").text(totalPrice);
    const priceCompareNum = totalComparePrice.replace(/[$,]/g, "");
    const priceNum = totalPrice.replace(/[$,]/g, "");
    const save = Number(priceCompareNum) - Number(priceNum);
    $(".product-bundle__total-save-value").text(
      "$" + (save > 0 ? save.toFixed(2) : "0.00")
    );
  });

  // Helper function to calculate per-item price
  function calculatePerItemPrice(totalPrice, itemCount) {
    if (!totalPrice || !itemCount || itemCount <= 0) return "$0.00";

    const numericPrice = parseFloat(totalPrice.replace(/[$,]/g, ""));
    if (isNaN(numericPrice)) return "$0.00";

    const perItemPrice = numericPrice / itemCount;
    const truncated = Math.floor(perItemPrice * 100) / 100;
    return "$" + truncated.toFixed(2);
  }

  $(document).on("click", ".product-bundle__buttons-item", function () {
    $(this).parent().find("div").removeClass("active-bundle");
    $(this).addClass("active-bundle");
    $(".product-bundle__data .single-tab-data").removeClass(
      "active-tab-detail"
    );
    if ($(this).hasClass("subscription-bundle")) {
      $(".product-bundle__data .product-bundle__data-subscription").addClass(
        "active-tab-detail"
      );
      $(".product-form__submit .product-price-total-btn").text(
        $(this)
          .parents(".custom-bundle-pdp")
          .find(
            ".product-bundle__data-subscription .single-product-data.selected-plan .final-product-price"
          )
          .text()
      );
      $(".product product-form .product-variant-id").val(
        $(".product-bundle__data-subscription .selected-plan").attr(
          "data-variant-id"
        )
      );
      $(".product-form__submit").removeAttr("disabled", "");

      $(".product product-form .product-selling-plan-id").val(
        $(this)
          .parents(".heading-bundle-data")
          .find(".product-bundle__data .all-data-products .selected-plan")
          .attr("data-subscription-id")
      );
      if (
        $(".product-bundle__data-subscription .selected-plan").attr(
          "data-product-avail"
        ) == "true"
      ) {
        $(".product .add-soldout-text").text("Add To Cart");
        $(".product .product-form__buttons .product-form__submit").removeAttr(
          "disabled",
          ""
        );
      } else {
        $(".product-form__submit").text("Sold Out");
        $(".product .product-form__buttons .product-form__submit").attr(
          "disabled",
          ""
        );
      }
    } else {
      $(".product-bundle__data .one-time-bundle-data").addClass(
        "active-tab-detail"
      );
      $(".product-form__submit .product-price-total-btn").text(
        $(this)
          .parents(".custom-bundle-pdp")
          .find(
            ".one-time-bundle-data .single-product-data.selected-plan .final-product-price"
          )
          .text()
      );
      $(".product product-form .product-selling-plan-id").val("");

      $(".product product-form .product-variant-id").val(
        $(".one-time-bundle-data .selected-plan").attr("data-variant-id")
      );
      $(".product-form__submit").removeAttr("disabled", "");
    }

    if ($(".product__info-wrapper").hasClass("commin-soon-product")) {
      $(".product .add-soldout-text").text("Coming Soon");
    }
  });

  // One Time Bundle Button Click Price update
  $(document).on(
    "click",
    ".one-time-bundle.product-bundle__buttons-item",
    function () {
      updateBundlePrice($(".one-time-bundle.selected-plan"));
    }
  );

  // Subscription Bundle Button Click Price update
  $(document).on(
    "click",
    ".subscription-bundle.product-bundle__buttons-item",
    function () {
      updateBundlePrice($(".subscription-bundle.selected-plan"));
    }
  );

  function updateBundlePrice($selectedPlan) {
    if (!$selectedPlan || !$selectedPlan.length) return;

    const price = $selectedPlan.attr("data-price") || "0";
    const priceCompare = $selectedPlan.attr("data-compare-price") || "0";
    const priceCompareNum = priceCompare.replace(/[$,]/g, "");
    const priceNum = price.replace(/[$,]/g, "");
    const save = Number(priceCompareNum) - Number(priceNum);
    $(".product-bundle__total-price-value").text(price);
    $(".product-bundle__total-save-value").text(
      "$" + (save > 0 ? save.toFixed(2) : "0.00")
    );
  }

  // Update the delivery date on PDP
  function getDatePlusFourDays() {
    const date = new Date();
    date.setDate(date.getDate() + 4);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });

    return `${day} ${month}`;
  }

  $(".expected-delivery-date").text(getDatePlusFourDays());

  // setTimeout(function () {
  //     StampedFn.loadBadges({ apiKey: 'pubkey-zuPL67824ke4ulxeKDK2mFXPD29y3Q', sId: '224726' });
  // }, 4000);
});
